import React, { FC } from 'react';

import useCookiePopup from '../../../hooks/useCookiePopup';
import useTranslation from '../../../hooks/useTranslation';
import CookieForm from '../../components/cookie-form/CookieForm';
import CookieModal from './CookieModal';

const Popup: FC = () => {
    const { modal, cookies, success } = useTranslation();

    const { closeModal, open, setOpen } = useCookiePopup(cookies, success.timeout);

    return (
        <CookieModal onClose={closeModal} open={open} title={modal.header}>
            <p className="consent-subheader">{modal.subHeader}</p>
            <CookieForm cookies={cookies} onCloseModal={() => setOpen(false)} />
        </CookieModal>
    );
};

export default Popup;
